<template>
  <div class="bg-dark">
  <section id="content" class="p-t-lg wrapper-md animated fadeInUp">
    <p style="background-color: #FFF;" class="text-center"><!--<?= $feedbackmessageKey ?> --></p>
    <div class="container aside-xl" style="text-align:center">
     <img src="../../public/static/img/logo.png"/>
     <!-- <h2 style="color: #fff" align="center">Al Nasiya Gen.Cont.LLC</h2> -->
     <h4 style="color: #fff" align="center"> Employee Login</h4> 
      <section class="m-b-lg" >
        <form @submit.prevent="checkCreds">
          <div class="list-group" >
            <div class="list-group-item" style="padding-top: 30px;">
              <span><!-- getFeedbackMessage() --></span>
              <input type="hidden" name="<?php echo $this->security->get_csrf_token_name(); ?>" value="<?php echo $this->security->get_csrf_hash(); ?>">
              <input type="text" required="" v-model="username" placeholder="User Name" autocomplete="off"  class="form-control no-border">
              <span class="help-block">
              <strong></strong></span>
            </div>
            <div class="list-group-item">
              <input type="password" v-model="password" placeholder="Password"  required="" name="password_of" autocomplete="off" class="form-control no-border">
              <span class="help-block">
              <strong></strong>
              </span>
            </div>
          </div>
          <button type="submit" class="btn btn-lg btn-primary btn-block">Sign in</button>
          <!-- <a href="<?= base_url(AppConst::INDEX.'reset-password')?>" style="color: #fff;text-align:left">Forgot Password?</a>-->
        </form>
      </section>
    </div>
  </section>

  <!-- footer -->

  <footer id="footer">
    <div class="text-center padder">
        <p class="copyright"> <small> Copyright &copy; 2022 Inprez</small> </p>
    </div>
  </footer>
  </div>
</template>


<script>
import api from '../api'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      response: ''
    }
  },
  methods: {
    checkCreds() {
      const { username, password } = this
      const inputs ={
          "login-info": {
            "username": username,
            "password": password,
            "platform": "WEB",
            "app_key": "ADMIN_WEB_CLIENT",
            "api_key": "4ned_key_2021",
            "device_notify_id": "",
            "device_UID": "12548795522"
          }
        }
      api
        // .request('post', 'GeneralApis/test', inputs, 'login')
        .request('post', 'GeneralApis/admin_user_auth', inputs, 'login')
        .then(response => {
          console.log(response)
          var data = response.data;
          if(data.errorcode){
            this.response = data.errormessage;
            return
          }
          if(data["authInfo"]) {
            var userAuth = data["authInfo"];
            console.log(userAuth)
            userAuth.auth_key = userAuth["device_access_key"];
            userAuth.app_key = "ADMIN_WEB_CLIENT";
            userAuth.api_key = "4ned_key_2021";
            this.$store.commit('SET_USER', userAuth)

            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(userAuth))
            }

            this.$router.push(data.redirect ? data.redirect : '/dashboard')
          }
        });
    } 
   
  }
}
</script>



<style scoped>
.bg-dark{
    background-color: #4b4f58;
    color: #7a87a7;
    height: 100%;
}
</style>
